import get from 'lodash/get';
import flow from 'lodash/flow';
import includes from 'lodash/includes';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectIsMobile, selectUserAgent } from 'src/common/selectors/app';
import { selectIsSubscriptionEnabled } from 'src/common/selectors/config';
import connectWithExperiments from '../../decorators/connectWithExperiments';
import PrerollDialog from '../ads/PrerollDialog';
import UnlockDialog from '../unlock/UnlockDialog';
import isContentPage from '../../utils/subscription/isContentPage';
import areGdprObligationsComplete from '../consent/utils/areGdprObligationsComplete';
import {
  WEB_FIRST_PLAY_INSTALL_APP_DIALOG,
  WEB_OPEN_INSTALL_APP_DIALOG,
  WEB_OPEN_INSTALL_APP_DIALOG_DISABLED_GUIDEIDS,
} from '../../constants/experiments/dialog';
import NowPlayingDialog from './NowPlayingDialog';
import DownloadAppDialog from './DownloadAppDialog';
import InAppMessageDialog from './InAppMessageDialog';
import TextMeTheAppDialog from './TextMeTheAppDialog';
import NavBasedDialogManager from './NavBasedDialogManager';
import PopoutPlayerDialog from './PopoutPlayerDialog';
import ErrorDialog from './ErrorDialog';
import LinkWithAlexaDialog from './LinkWithAlexaDialog';
import ShareDialogContainer from './ShareDialogContainer';
import InterestSelectorDialog from './InterestSelectorDialog';

export class GlobalDialogs extends Component {
  static propTypes = {
    breakpoint: PropTypes.number.isRequired,
    routeProps: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    // mapStateToProps
    isSubscriptionEnabled: PropTypes.bool.isRequired,
    userAgent: PropTypes.string,
    gdprObligationsComplete: PropTypes.bool.isRequired,
    // connectWithExperiments
    [WEB_OPEN_INSTALL_APP_DIALOG]: PropTypes.bool,
    [WEB_OPEN_INSTALL_APP_DIALOG_DISABLED_GUIDEIDS]: PropTypes.string,
    [WEB_FIRST_PLAY_INSTALL_APP_DIALOG]: PropTypes.bool,
  };

  render() {
    const {
      // Parent
      breakpoint,
      routeProps,
      history,
      // map state to props
      isSubscriptionEnabled,
      userAgent,
      gdprObligationsComplete,
      // connectWithExperiments
      [WEB_OPEN_INSTALL_APP_DIALOG]: openInstallDialogExperiment,
      [WEB_OPEN_INSTALL_APP_DIALOG_DISABLED_GUIDEIDS]:
        hideInstallDialogGuideIdsExperiment,
      [WEB_FIRST_PLAY_INSTALL_APP_DIALOG]: firstPlayInstallDialogExperiment,
    } = this.props;

    const hideInstallDialogGuideIds = hideInstallDialogGuideIdsExperiment
      ? hideInstallDialogGuideIdsExperiment.split(',')
      : '';

    return (
      <div>
        {!routeProps.hideAds && <PrerollDialog breakpoint={breakpoint} />}
        <NavBasedDialogManager
          isSubscriptionEnabled={isSubscriptionEnabled}
          routeProps={routeProps}
          history={history}
          key={`NavBasedDialogManager-${routeProps.matchUrl}`}
        />
        <InterestSelectorDialog />
        <LinkWithAlexaDialog />
        <InAppMessageDialog />
        <UnlockDialog />
        <NowPlayingDialog breakpoint={breakpoint} routeProps={routeProps} />
        {(isContentPage(routeProps) || routeProps.isLanding) &&
          gdprObligationsComplete && (
            <TextMeTheAppDialog routeProps={routeProps} userAgent={userAgent} />
          )}
        {(openInstallDialogExperiment || firstPlayInstallDialogExperiment) &&
          !includes(
            hideInstallDialogGuideIds,
            get(routeProps, 'guideContext.guideId'),
          ) && <DownloadAppDialog />}
        <PopoutPlayerDialog />
        <ErrorDialog />
        <ShareDialogContainer />
      </div>
    );
  }
}

export const mapStateToProps = (state) => ({
  isMobile: selectIsMobile(state),
  userAgent: selectUserAgent(state),
  isSubscriptionEnabled: selectIsSubscriptionEnabled(state),
  gdprObligationsComplete: areGdprObligationsComplete(state),
});

export default flow(
  connectWithExperiments([
    WEB_OPEN_INSTALL_APP_DIALOG,
    WEB_OPEN_INSTALL_APP_DIALOG_DISABLED_GUIDEIDS,
    WEB_FIRST_PLAY_INSTALL_APP_DIALOG,
  ]),
  connect(mapStateToProps),
)(GlobalDialogs);
